<template>
  <v-container fluid style="width: 100%" class="px-5">
    <div v-if="$route.name === names.REGULAR_PASSES.LIST">
      <v-toolbar
          class="removeBtnPaddingRight rounded-t-lg"
          color="#DADADA"
          flat
      >
        <v-text-field
            clearable
            outlined
            dense
            single-line
            :disabled="isLoading"
            v-model="search.value" label="Поиск" hide-details @keydown.enter="searchData" @click:clear="clearSearchData">
        </v-text-field>
        <v-spacer></v-spacer>
        <v-btn
            v-if="$vuetify.breakpoint.xsOnly && action_allowed"
            icon
            class="mr-0 dark-primary"
            @click="newRegularPass"
        >
          <v-icon>add</v-icon>
        </v-btn>
        <v-btn
                v-if="$vuetify.breakpoint.smAndDown"
                icon
                class="mr-0 dark-primary"
                @click="generateFile"
        >
            <v-icon>cloud_download</v-icon>
        </v-btn>
        <v-toolbar-items v-if="$vuetify.breakpoint.smAndUp ">
          <v-btn
              v-if="action_allowed"
              text
              @click="newRegularPass"
              class="rounded-tr-lg dark-primary"
          >
            Добавить новый
          </v-btn>
          <v-btn
                  v-if="$vuetify.breakpoint.mdAndUp"
                  class="rounded-tr-lg dark-primary"
                  text
                  @click="generateFile"
          >
              Скачать
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-data-table
          :headers="headers"
          :items="items"
          :loading="isLoading"
          :page.sync="pagination.page"
          :items-per-page.sync="pagination.size"
          :server-items-length="count"
          :options.sync="options"
          multi-sort
          :footer-props="{'items-per-page-options':[10,50,100]}"
          class="elevation-1 rounded-b-lg"
      >
        <template v-slot:item.territories="{ item }">
          <span  v-for="(territory, index) in item.territories"
                 :key="index">
                {{territory.name}}
            <span v-if="index + 1 !== item.territories.length">,
            </span>
          </span>
        </template>
        <template v-slot:item.actions="{ item }" v-if="action_allowed">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                  class="mr-2"
                  @click="editRegularPass(item)"
                  v-bind="attrs"
                  v-on="on"
              >
                edit
              </v-icon>
            </template>
            <span>Редактировать</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                  @click="deleteRegularPass(item)"
                  v-bind="attrs"
                  v-on="on"
              >
                delete
              </v-icon>
            </template>
            <span>Удалить</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          <v-btn
              color="primary"
              @click="updateData()"
          >
            Обновить
          </v-btn>
        </template>
      </v-data-table>
      <EditDialog
          v-if="dialog_add_edit"
          :opened="dialog_add_edit"
          :edit="edit_status"
          :regular-pass-data="regularPasses_data"
          @close="closeEditDialog"
      ></EditDialog>
      <download-file-dialog
              v-if="dialog_download"
              :opened="dialog_download"
              :choices="choices"
              :unloading-from="unloadingFile"
              @close="closeDownloadDialog"
      ></download-file-dialog>
      <ApplyDialog
          v-if="dialog_delete"
          :opened="dialog_delete"
          :get-text="() => `Вы уверены, что хотите удалить пропуск ?`"
          @close="closeDeleteDialog"
      ></ApplyDialog>
    </div>
    <router-view v-else></router-view>
  </v-container>
</template>

<script>
import names from "../routers/names";
import TitledPageMixin from "@/mixins/TitledPageMixin";
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin";
import {mapActions, mapGetters} from "vuex";
import entitled from "@/urls/roles/entitled";
import names_core from "@/modules/core/routers/names";
import EditDialog from "@/modules/entitled/regularpasses/modals/RegularPassesEditDialog.vue";
import ApplyDialog from "@/modules/core/components/ApplyDialog.vue";
import DownloadFileDialog from "./modals/DownloadFileDialog.vue";
export default {
  name: "RegularPassesList",
  components: {EditDialog, ApplyDialog, DownloadFileDialog},
  mixins: [TitledPageMixin, PaginatedDataMapperMixin],
  data() {
    return {
      page_title: "Список постоянных пропусков",
      action_allowed: false,
      dialog_add_edit: false,
      dialog_delete: false,
      dialog_download: false,
      edit_status: undefined,
      regularPasses_data: undefined,
      search: {
        parameter: "search"
      },
      choices: {
          order_type: [],
          order_status: [],
          order: [{value: "regular_passes", text: "Все заявки"}]
      },
      headers: [
        {text: "Посетитель", value: "visitor", align: "start", sortable: true, width: "20%"},
        {text: "Подразделение", value: "department", align: "start", sortable: true, width: "25%"},
        {text: "Территория", value: "territories", align: "start", sortable: true, width: "15%"},
        {text: "Марка", value: "model", align: "start", sortable: true, width: "10%"},
        {text: "Номер", value: "car", align: "start", sortable: true, width: "10%"},
      ]
    }
  },
  computed: {
    names: () => names,
    ...mapGetters({
      items: "entitled/getRegularPasses",
      count: "entitled/getRegularPassesCount",
      isLoading: "entitled/isLoadingRegularPasses",
      getCurrentUrl: "entitled/getRegularPassesCurrentUrl"
    })
  },
  methods: {
    ...mapActions({
      loadRegularPassesList: "entitled/loadRegularPassesList",
      deleteRegularPasses: "entitled/deleteRegularPasses",
      unloadingFile: "entitled/unloadingFile",
      loadOrderTypeChoices: "choices/loadOrderTypeChoices",
      loadOrderStatusChoices: "choices/loadOrderStatusChoices"
    }),
    updateData(){
      if (this.search.value) {
        this.search.value = ""
      }
      this.loadData()
    },
    loadData(url = undefined) {
      this.loadRegularPassesList({
        url: url,
        urlAppend: (url) => {
          let new_url = this.addPageParameter(this.addSizeParameter(url))
          if (this.search.value)
            new_url = this.addGetParameter(new_url, "search", this.search.value)
          return new_url
        },
        finalizer: (data, url) => {
          this.setCurrentLoadUrl(url);
        }
      })
    },
    loadChoices() {
        this.loadOrderTypeChoices({
            url: undefined,
            finalizer: (val) => {
                this.choices.order_type = val
            }
        })
        this.loadOrderStatusChoices({
            url: undefined,
            finalizer: (val) => {
                this.choices.order_status = val
                this.choices.order_status.splice(0, 1)
            }
        })
    },
    generateFile(){
        this.dialog_download = true
    },
    newRegularPass() {
      this.dialog_add_edit = true
      this.edit_status = false
      this.regularPasses_data = undefined
    },
    editRegularPass(item) {
      this.dialog_add_edit = true
      this.edit_status = true
      this.regularPasses_data = item
    },
    deleteRegularPass(item) {
      this.dialog_delete = true
      this.regularPasses_data = item
    },
    closeEditDialog(event) {
      this.loadData()
      this.dialog_add_edit = false
      this.regularPasses_data = undefined
    },
    closeDownloadDialog(event) {
        this.loadData()
        this.dialog_download = false
    },
    closeDeleteDialog(event) {
      if (event) {
        this.deleteRegularPasses({
          id: this.regularPasses_data.id,
          finalizer: (val) => {
            this.loadData()
          },
          catcher: (val) => {
            this.mapErrors(val)
          }
        })
      }
      this.dialog_delete = false
      this.regularPasses_data = undefined
    }
  },
  created() {
    if (entitled.ENTITLED.REGULAR_ACTION_ALLOWED()) {
      this.action_allowed = true
      this.headers.push({text: "Действия", value: "actions", sortable: false, align: "center", width: "20%"})
    }
    if (entitled.ENTITLED.ALLOWED()){
      if (this.getCurrentUrl) {
        this.loadFromSavedUrl(this.getCurrentUrl)
      } else {
        this.loadData()
      }
      this.loadChoices()
    }
    else{
      this.$router.push({name: names_core.MAIN}).catch(() => {})
    }
  }
}
</script>

<style scoped>
.removeBtnPaddingRight>>>.v-toolbar__content{
  padding-right: 0px;
}
</style>
